<script lang="ts">
    import { t } from "@lernetz/svelte-translate";
    import { Link } from "@inertiajs/svelte";
    import { getLocale } from '../utils/getLocale';

    export let to:string;
    export let title:string;
    export let image:string;

    const locale = getLocale();

</script>

<Link href={locale + to}>
    <div class="h-[320px] rounded-2xl flex flex-col items-center transition-all duration-200 bg-light-grey hover:bg-medium-grey">
        <div class="font-bold text-18 mt-32 text-center">
            {$t(title)}
        </div>
        <img
            alt={$t(title)}
            class="object-contain h-240"
            src="/images/{image}"
        />
    </div>
</Link>
